import { 
  WAIT_INIT_COMPANY, INIT_COMPANY_SUCCESS, INIT_COMPANY_FAIL, SAVE_COMPANY_INFO, SAVE_COMPANY_INFO_SUCCESS, SAVE_COMPANY_INFO_FAIL
} from '../actions/company/index';

const doAction = (state, action) => {
  switch (action.type) {
    case WAIT_INIT_COMPANY:
      return {
        ...state,
        status: WAIT_INIT_COMPANY,
        errMsg: null,
        companyInfo: {
          loading: true
        },
        loading: true
      }
    case INIT_COMPANY_SUCCESS:
      return {
        ...state,
        status: INIT_COMPANY_SUCCESS,
        companyInfo: action.params.companyInfo,
        loading: false
      }
    case INIT_COMPANY_FAIL:
      return {
        ...state,
        companyInfo: {
          loading: true
        },
        errMsg: action.params.errMsg,
        status: INIT_COMPANY_FAIL,
        loading: true
      }
    case SAVE_COMPANY_INFO:
      return {
        ...state,
        status: SAVE_COMPANY_INFO,
        successMsg: null,
        errMsg: null,
        companyInfo: {
          ...state.companyInfo,
          loading: true
        },
      }
    case SAVE_COMPANY_INFO_SUCCESS:
      return {
        ...state,
        status: SAVE_COMPANY_INFO_SUCCESS,
        successMsg: action.params.successMsg,
        companyInfo: action.params.companyInfo,
      }
    case SAVE_COMPANY_INFO_FAIL:
      return {
        ...state,
        status: SAVE_COMPANY_INFO_FAIL,
        errMsg: action.params.errMsg,
        companyInfo: {
          ...state.companyInfo,
          loading: false
        },
      }
  default:
    return state;
  }
}

const companyReducers = (state = {
  status: WAIT_INIT_COMPANY,
  companyInfo: {
    loading: true
  },
  loading: true,
  successMsg: null,
  errMsg: null
}, action) => {
  switch (action.type) {
    default:
      return doAction(state, action);
  }
}

export default companyReducers;